import axios from 'axios'
import { API_ENDPOINT } from '../../../config'
import store from '../../../redux/stores/store'

const getDefaultState = () => {
    return {
        loading: false,
        deletingId: null,
        tourPackages: [],
        filter: {
            column: "",
            value: ""
        },
        selectedIndex: -1,
        currentPage: 1,
        pageSize: 50,
        total: 0
    }
}

const loadTourPackages = instance => {
    instance.setState({ ...instance.state, loading: true })

    let criteria = {}
    if (instance.state.filter.column.length > 0 && instance.state.filter.value.length > 0) {
        criteria = {
            [instance.state.filter.column]: instance.state.filter.value
        }
    }

    axios({
        method: 'post',
        url: API_ENDPOINT + "/api/tour-packages",
        headers : {
            "Authorization": store.getState().auth.authorization
        },
        data: {
            offset: (instance.state.currentPage - 1) * instance.state.pageSize,
            limit: instance.state.pageSize,
            criteria: criteria
        }
    }).then(response => handleLoadTourPackagesResponse(instance, response))
    .catch(error => alert(error))
}

const handleLoadTourPackagesResponse = (instance, response) => {
    if (response.status === 200 && response.data.status === 200) {
        const tourPackages = response.data.data.tourPackages || response.data.data.packages || []
        instance.setState({
            ...instance.state,
            loading: false,
            tourPackages: tourPackages
        })
    }
    else if (response.data.status === 403) {
        instance.props.history.push('/auth/login')
    }
}

const TourPackagesWorker = instance => {
    const deleteTourPackage = id => {
        instance.setState({ ...instance.state, deletingId: id })
        axios({
            method: 'post',
            url: API_ENDPOINT + "/api/tour-package/delete",
            headers : {
                "Authorization": store.getState().auth.authorization
            },
            data: {
                id: id
            }
        }).then(response => handleDeleteTourPackageResponse(instance, response, id))
        .catch(error => alert(error))
    }

    const handleDeleteTourPackageResponse = (instance, response, id) => {
        if (response.status === 200 && response.data.status === 200) {
            instance.setState({
                ...instance.state,
                deletingId: null,
                tourPackages: instance.state.tourPackages.filter((tourPackage) => tourPackage.id !== id)
            })
        }
        else if (response.data.status === 403) {
            instance.props.history.push('/auth/login')
        }
        else {
            instance.setState({
                ...instance.state,
                deletingId: null
            })
        }
    }

    return {
        loadTourPackages: () => loadTourPackages(instance),
        getDefaultState: () => getDefaultState(instance),
        deleteTourPackage: (id) => deleteTourPackage(id)
    }
}

export default TourPackagesWorker
